import { QuestionBase } from './question-base';

export class BooleanDropdownQuestion extends QuestionBase<string> {
    override controlType = 'boolean-dropdown';
}
